const TopPosts = () => {
  return <h1>My TopPosts</h1>;
};

export default TopPosts;
